// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadImage_container__DgwSs","overlay":"UploadImage_overlay__u2dOu","deleteButton":"UploadImage_deleteButton__38F8S"};